interface NoDataProps {
  text?: string;
}

const NoData = ({ text = "No data available" }: NoDataProps) => (
  <div className="noDataMessage">{text}</div>
);

export default NoData;
